import React, { useEffect, useState } from "react";
import Parse from "../../api/ApiConfig";
import { Outlet, useNavigate, useParams } from "react-router";
import AdminDashboardLayout from "../../layout/AdminDashboardLayout";
import { HeaderWrapper } from "./Logistics.styled";
import FilterCategory from "../../components/ReusableComponents/FilterCategory";
import { Backdrop, CircularProgress } from "@mui/material";
import { TabList } from "./data";
import LogisticsTable from "./sections/LogisticsTable";
import { fetchTableData } from "./utils";
import { toast } from "react-toastify";
import { StyledContainer } from "../../globalStyle/GlobalStyle";
import LogisticsHeader from "./sections/LogisticsHeader";
import { setCurrentFilter, setCurrentTab, setTableData } from "./LogisticSlice";
import { useDispatch, useSelector } from "react-redux";
import { BiArrowBack } from "react-icons/bi";
import { getCurrentUserInfo } from "../../utils/UserAuth";

/* eslint-disable no-unused-vars */
const Logistics = () => {
	let navigate = useNavigate();
	const dispatch = useDispatch();
	let { category, id: requestId } = useParams();

	const { currentTab, currentFilter, tableData } = useSelector((state) => state.logistics);

	const [currentTable, setCurrentTable] = useState(null);
	const [defaultData, setDefaultData] = useState([]);
	const [loading, setLoading] = useState(false);

	const getTableData = async (category, filter) => {
		let _category = category || currentTab;
		const data = await fetchTableData(_category, filter || currentFilter);

		if (data && !data.error) {
			setLoading(false);
			setDefaultData(data);
			setCurrentTable(_category);
			dispatch(setTableData(data));
		} else {
			setLoading(false);
			dispatch(setTableData([]));
			toast.error("Error fetching data!");
		}
	};

	const newTabList = () => {
		if (getCurrentUserInfo()?.role === "Logistics") {
			return TabList.filter((tab) => tab.id !== "awaiting_purchase")[0];
		} else {
			return TabList[0];
		}
	};

	useEffect(() => {
		if (category) {
			dispatch(setCurrentTab(category));
			// If category is different from currentTable, fetch data
			if (category !== currentTable) {
				setLoading(true);
				getTableData(category);
			}
		} else {
			navigate(`/logistics/${newTabList()?.id}`, { replace: true });
			// navigate(`/logistics/${currentTab}`, { replace: true });
		}
	}, [category]);

	const handleTabChange = (category) => {
		if (category !== currentTab) {
			navigate(`/logistics/${category}`);
		} else {
			// If category is same as currentTab, then refetch data
			setLoading(true);
			getTableData(category);
		}
	};

	const handleFilterChange = (e) => {
		dispatch(setCurrentFilter(e.target.value));
		setLoading(true);
		getTableData(null, e.target.value);
	};

	const handleDeleteLOG = async (selected) => {
		setLoading(true);
		const isLeasing = currentFilter === "lease";
		if (selected.length && isLeasing) {
			// console.log("selected", selected);
			setLoading(false);
			handleDeletion(selected, "Lease");
		} else if (selected.length && !isLeasing) {
			// console.log("selected", selected);
			setLoading(false);
			handleDeletion(selected, "ApprenticeshipFinance");
		} else {
			toast.error("No Item selected");
			setLoading(false);
		}
	};

	const handleDeletion = async (selected, type) => {
		setLoading(true);
		const LogisticObjects = selected.map((item) => {
			const LogObj = new Parse.Object(type);
			LogObj.id = item.objectId;
			return LogObj;
		});

		Parse.Object.destroyAll(LogisticObjects)
			.then((object) => {
				getTableData(category);
				console.log("Logistic objects deleted successfully", object);
				toast.success("Logistic item deleted successfully");
				setLoading(false);
			})
			.catch((error) => {
				setLoading(false);
				console.error("Error while deleting Logistic", error);
				toast.error("Error deleting logistic item");
				setLoading(false);
			});
	};

	const handleBackButton = () => {
		navigate(`/logistics/${category}`);
	};

	return (
		<AdminDashboardLayout
			data={tableData}
			defaultData={defaultData}
			setData={(data) => dispatch(setTableData(data))}>
			<StyledContainer>
				<HeaderWrapper>
					{!requestId && <LogisticsHeader currentFilter={currentFilter} currentTab={currentTab} />}

					{requestId && (
						<div className='topHeader flex'>
							<div onClick={handleBackButton} style={{ color: "#006770" }} className='flex gap-2 border px-3'>
								<BiArrowBack size={24} />
								<p>Go back</p>
							</div>
						</div>
					)}

					<FilterCategory
						currentTab={currentTab}
						tabList={TabList}
						handleClick={(category) => handleTabChange(category)}
					/>
				</HeaderWrapper>

				<>
					{requestId ? (
						<Outlet context={[loading, setLoading]} />
					) : (
						<LogisticsTable handleFilterChange={handleFilterChange} handleDeleteLOG={handleDeleteLOG} />
					)}
				</>
			</StyledContainer>

			{loading && (
				<Backdrop sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }} open={loading}>
					<CircularProgress color='inherit' />
				</Backdrop>
			)}
		</AdminDashboardLayout>
	);
};

export default Logistics;
